import { Button } from '@routific/hive';
import { useTranslation } from 'react-i18next';
import {
  Control, FieldValues, useForm, useWatch,
} from 'react-hook-form';

interface Props {
  control?: Control<FieldValues, any>
  onOk: () => void;
  isInputError?: boolean;
  isLoading: boolean;
  hasSelection: boolean;
}

const ExportButton: React.FC<Props> = ({ control, onOk, isInputError, isLoading, hasSelection }) => {
  const { t } = useTranslation('components');
  // Fallback keeps useWatch unconditional (hooks can't be called conditionally) when no control is passed.
  const { control: fallbackControl } = useForm();
  const dateRange = useWatch({
    control: control ?? fallbackControl,
    name: ['dateRange'],
  });

  const isDateRangeComplete = !control || (dateRange[0] && dateRange[0][0] !== undefined && dateRange[0][1] !== undefined);
  const isExportDisabled = !isDateRangeComplete || !!isInputError || isLoading || !hasSelection;

  return <Button key="export" type="primary" onClick={onOk} disabled={isExportDisabled} data-testid="export-button" loading={isLoading}>
    {t('downloadCSVModal.export')}
  </Button>;
};

export default ExportButton;
